import { MuiTelInput, MuiTelInputProps } from 'mui-tel-input'
import { useMemo } from 'react'
import { Controller, FieldValues, Path, useFormContext } from 'react-hook-form'

import Flag from '@/app/component/atom/flag'
import { isCountryCode } from '@/app/service/util/country'

type Props<T extends FieldValues> = {
  name: Path<T>
  defaultCountry?: string
  disabled?: boolean
  placeholder?: string
} & Pick<MuiTelInputProps, 'label' | 'autoFocus' | 'required'>

export function RHFPhoneField<T extends FieldValues>({ name, defaultCountry, ...props }: Props<T>) {
  const { control } = useFormContext<T>()

  const countryCode = useMemo(() => {
    if (props.disabled || !defaultCountry || !isCountryCode(defaultCountry)) {
      return undefined
    }

    return defaultCountry
  }, [defaultCountry, props.disabled])

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <MuiTelInput
          {...field}
          {...props}
          defaultCountry={countryCode}
          error={!!error}
          fullWidth
          helperText={error?.message}
          size="small"
          slotProps={{
            htmlInput: {
              'aria-label': name,
            },
          }}
          sx={{ mb: 2 }}
          variant="standard"
          getFlagElement={(isoCode, { imgProps: { width } }) => <Flag code={isoCode} width={width} />}
        />
      )}
    />
  )
}
